<template>
	<a-card>
		<a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
			<template #message>
				已选择 {{ selectedRowKeys.length }} 项
				<a @click="onClearSelected" class="ml-20 float-right">清空</a>
			</template>
		</a-alert>
		<a-table :columns="columns" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
			:pagination="pagination" :data-source="dataSource" :loading="loading" @change="onTableChange">
			<template #companyName="{ record }">
				<a @click="onCompanyDetail(record)">{{ record.companyName }}</a>
			</template>
			<template #jobTitle="{ record }">
				<a @click="onJobDetail(record)">
					<dict-render :dict-obj="dictObjs['hope_job']" :text="record.jobTitle"></dict-render>
				</a>
			</template>
			<template #industry="{ text }">
				<dict-render :dict-obj="dictObjs['research_field']" :text="text"></dict-render>
			</template>
			<template #educationBackground="{ text }">
				<dict-render :dict-obj="dictObjs['education_background']" :text="text"></dict-render>
			</template>
			<template #salary="{ text }">
				<dict-render :dict-obj="dictObjs['salary']" :text="text"></dict-render>
			</template>
			<template #workExperience="{ text }">
				<dict-render :dict-obj="dictObjs['work_experience']" :text="text"></dict-render>
			</template>
			<template #isShow="{ record }">
				<switch-btn :value="record.isShow" key-field="isShow" :switch-url="editUrl" :checkedValue="'0'"
					:uncheckedValue="'1'" :params="{ id: record.key }" @ok="loadData" />
			</template>
			<template #action="{ record }">
				<div class="table-row-operations">
					<a @click="onEdit(record)">编辑</a>
				</div>
			</template>
		</a-table>
	</a-card>
	<DetailModal ref="detailModal" :form-primary-key-field="listKeyField" />
</template>

<script>
import DetailModal from './components/DetailModal';
import { dictMixin, tableListMixin } from "@/mixins";
import { talentUserViewInfo, enterpriseRrecruitmentInfo } from "@/api/educationService";
import DictRender from "@/components/other/DictRender";
import { dateFormat } from "@/config/variableConfig";
import { showCity } from "@/utils/util";

const columns = [
	// {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
	{ title: "职位名称", dataIndex: "jobTitle", key: "jobTitle", slots: { customRender: "jobTitle" } },
	{ title: "企业名称", dataIndex: "companyName", key: "companyName" },
	{ title: '学历', dataIndex: "educationBackground", key: "educationBackground", slots: { customRender: "educationBackground" } },
	{ title: '薪资', dataIndex: "salary", key: "salary", slots: { customRender: "salary" } },
	{ title: '工作经验', dataIndex: "workExperience", key: "workExperience", slots: { customRender: "workExperience" } },
	{ title: "投递时间", dataIndex: "createdTime", key: "createdTime" },
	// { title: "操作", dataIndex: "action", key: "action", slots: { customRender: "action" } },
];
export default {
	name: "index",
	mixins: [tableListMixin, dictMixin],
	components: {
		DetailModal, DictRender
	},
	data() {
		return {
			dateFormat,
			dictNames: 'research_field,education_background,salary,work_experience,hope_job',
			columns,
			queryParamFixed: { type: 0},
			listUrl: talentUserViewInfo.pageList,
			listKeyField: "id",
		}
	},
	methods: {
		onJobDetail(record) {
			this.getAction({
				url: enterpriseRrecruitmentInfo.detail,
				params: { id: record.id }
			}).then(res => {
				let obj = {
					...res,
					provject: showCity(res.prov, res.city, res.dist)
				}
				this.onShowModal('detailModal', obj);
			})
		},
	}
}
</script>

<style scoped></style>
